module.exports = __webpack_public_path__ + "media/images/client-15-2025640614e62fe061051bc52525cbb3.png";